module.exports = __webpack_public_path__ + "static/media/sf-trial-3.c57c2e94.mp3";